import { createAsyncThunk } from '@reduxjs/toolkit';
import { activeSnack } from '../store/common';
import { get } from './http';

export const getAllYoutubeShorts = createAsyncThunk('short/list', async ({ page, search, dispatch, limit, sortBy }) => {
  try {
    const URL = `/short/user/all?page=${page || ''}&search=${search || ''}&limit=${limit || ''}&sortBy=${sortBy || ''}`;

    const response = await get(URL);
    if (response) {
      return {
        list: response?.shorts,
        total: response?.total,
      };
    }
    return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
  } catch (error) {
    dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
    throw error?.response?.data?.message;
  }
});
